import { RootInstance } from '@store'

export const prepareSearchFacet = (
  facet: string
): string | RootInstance['search']['searchFacet'] => {
  return facet.trim().toLocaleLowerCase().replace(/\s/g, '_')
}
